(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-categories"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-faq"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-hero"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

/* Arthouse split hero carousel */
(function(){
  function init(hero){
    if(!hero || hero.dataset.ahReady) return; hero.dataset.ahReady='1';
    var track=hero.querySelector('[data-track]');
    if(!track) return;
    var slides=Array.prototype.slice.call(track.children);
    var total=slides.length; if(!total) return;
    var dotsWrap=hero.querySelector('[data-dots]');
    var index=0,timer=null;
    var delay=parseInt(hero.dataset.delay,10)||7000;
    var auto=hero.dataset.autoplay==='true';
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots=[];
    if(dotsWrap){
      slides.forEach(function(_,i){
        var b=document.createElement('button');
        b.setAttribute('role','tab');b.setAttribute('aria-label','Go to slide '+(i+1));
        b.addEventListener('click',function(){go(i);restart();});
        dotsWrap.appendChild(b);dots.push(b);
      });
    }
    function render(){
      track.style.transform='translateX('+(-index*100)+'%)';
      dots.forEach(function(d,i){d.setAttribute('aria-current',i===index?'true':'false');});
      slides.forEach(function(s,i){
        var on=(i===index);
        s.classList.toggle('is-active',on);
        s.inert=!on; s.setAttribute('aria-hidden',!on);
      });
    }
    function go(i){index=(i+total)%total;render();}
    function next(){go(index+1);} function prev(){go(index-1);}
    function play(){if(!auto||reduce||timer||total<2)return;timer=setInterval(next,delay);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function restart(){stop();play();}
    var n=hero.querySelector('[data-next]'),p=hero.querySelector('[data-prev]');
    if(n)n.addEventListener('click',function(){next();restart();});
    if(p)p.addEventListener('click',function(){prev();restart();});
    hero.addEventListener('mouseenter',stop);hero.addEventListener('mouseleave',play);
    hero.addEventListener('focusin',stop);hero.addEventListener('focusout',play);
    document.addEventListener('visibilitychange',function(){document.hidden?stop():play();});
    var sx=0,sy=0,dx=0,drag=false,lock=null;
    track.addEventListener('pointerdown',function(e){drag=true;lock=null;sx=e.clientX;sy=e.clientY;dx=0;stop();});
    track.addEventListener('pointermove',function(e){
      if(!drag)return;
      var mx=e.clientX-sx,my=e.clientY-sy;
      if(lock===null&&(Math.abs(mx)>6||Math.abs(my)>6)){
        lock=Math.abs(mx)>Math.abs(my)?'x':'y';
        if(lock==='x'){track.classList.add('is-drag');if(track.setPointerCapture){try{track.setPointerCapture(e.pointerId);}catch(err){}}}
      }
      if(lock!=='x')return;
      dx=mx;track.style.transform='translateX(calc('+(-index*100)+'% + '+dx+'px))';
    });
    function end(){if(!drag)return;drag=false;track.classList.remove('is-drag');if(lock==='x'&&Math.abs(dx)>60){dx<0?next():prev();}else{render();}lock=null;restart();}
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);
    hero.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){next();restart();}if(e.key==='ArrowLeft'){prev();restart();}});
    render();play();
  }
  function boot(){document.querySelectorAll('[data-ah-hero]').forEach(init);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){var h=e.target.querySelector('[data-ah-hero]');if(h){h.dataset.ahReady='';init(h);}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-links"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-products"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-promo"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-realhomes"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-reviews"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-sample"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-seo"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-ah-story"] && !Shopify.designMode) return;
  try {
    
/* Arthouse reveal-on-scroll (self-contained, runs once) */
(function(){
  if(window.ahRevealInit)return;window.ahRevealInit=true;
  if(!('IntersectionObserver' in window))return;
  document.documentElement.classList.add('ah-animate');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  function scan(r){(r||document).querySelectorAll('.ah .ah-reveal:not(.is-in)').forEach(function(el){io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',function(){scan();});
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.initSwatchOptionImage();
              window.initVariantChanger(this);
              window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
              window.initCompare();
            }
      const   swiperItems = document.querySelectorAll('.product-recommendations'),
              sliderOptions = $(swiperItems).attr('data-slider-options'),
               slideroptionConfig = $.parseJSON(sliderOptions),
               recommedndationSlider = new Swiper(".product-recommendations", slideroptionConfig);
               $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js"); 
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
